/* eslint-disable no-console */
import Immerable from '@naruto/naruto-models/src/types/GeneralImmer';
import { PrintItem } from './types';

class Debug extends Immerable {
  printInConsole(items: PrintItem[]): void {
    console.log('------------');
    items.forEach(item => {
      console.log(item.name, item.value);
    });
    console.log('------------');
  }
}

export default Debug;
